import {RESET_SMART_FLAGS} from "../actions";

export const SMART_FLAGS_CHECK_SUCCESS = 'SMART_FLAGS_CHECK_SUCCESS'
export const SMART_FLAGS_CHECK_FAIL = 'SMART_FLAGS_CHECK_FAIL'

export const defaultSmartFlagState = {
  smartFlagChecks: null,
  smartFlagEvaluatedTestIds: null,
  smartFlagChecksDone: false,
  error: false,
  errorMessage: null,
};

export default (state = defaultSmartFlagState, action) => {
  switch (action.type) {
    case SMART_FLAGS_CHECK_SUCCESS: {
      const payload = action.payload.data;
      const smartFlagChecks = Array.isArray(payload) ? payload : payload.results;
      const smartFlagEvaluatedTestIds = Array.isArray(payload) ? null : payload.evaluatedTestIds;

      return {
        ...state,
        smartFlagChecks,
        smartFlagEvaluatedTestIds,
        smartFlagChecksDone: true,
        error: false,
        errorMessage: null,
      };
    }
    case SMART_FLAGS_CHECK_FAIL:
      return {
        ...state,
        smartFlagChecks: null,
        smartFlagEvaluatedTestIds: null,
        smartFlagChecksDone: false,
        error: true,
        errorMessage: action.error.response.statusText
      };
    case RESET_SMART_FLAGS: {
      return {
        ...state,
        smartFlagChecks: null,
        smartFlagEvaluatedTestIds: null,
        smartFlagChecksDone: false,
        error: false,
        errorMessage: null,
      };
    }
    default:
      return {
        ...state
      };
  }
}
